import omit from "lodash/omit"

// Filter out 'extra' data that we're not already manually processing
// in other words, 'notExtras' get processed manually in mergeConnectionResults(),
// while notExtras fields are just merged in naively.
const notExtras = ["nodes", "edges", "pageInfo"]
const getExtras = (obj) => omit(obj, notExtras)

export default getExtras
